// fork from RBMC

const urlService = {
    baseUrl: undefined,
    getBaseUrl() {
        return this.baseUrl;
    },
    getSiteOrigin() {
        return window.location.origin;
    },
    getParameter(sParam) {
        // backport from urlService.js (angularJS)
        let sPageURL      = window.location.search.substring(1);
        let sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] == sParam) {
                return sParameterName[1];
            }
        }
    }
};

(function () {
    urlService.baseUrl = document.querySelector('html').dataset.baseUrl;
})();

export default urlService;
